import api from './api';

export const listingService = {
  getAll: async (filters = {}) => {
    const params = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== '' && v !== null && v !== undefined)
    );
    const res = await api.get('/Listing/GetAll', { params });
    return res.data.data;
  },

  getById: async (id) => {
    const res = await api.get(`/Listing/GetById/${id}`);
    return res.data.data;
  },

  getByListingNo: async (listingNo) => {
    const res = await api.get(`/Listing/GetByListingNo/${listingNo}`);
    return res.data.data;
  },

  getBySeller: async (sellerId) => {
    const res = await api.get(`/Listing/GetBySeller/${sellerId}`);
    return res.data.data;
  },

  create: async (payload) => {
    const res = await api.post('/Listing/Create', payload);
    return res.data.data;
  },

  update: async (id, payload) => {
    const res = await api.put(`/Listing/Update/${id}`, payload);
    return res.data.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/Listing/Delete/${id}`);
    return res.data.data;
  },

  reserve: async (listingId) => {
    const res = await api.post('/Listing/Reserve', { listingId });
    return res.data.data;
  },

  getByBounds: async ({ swLat, swLng, neLat, neLng, limit = 80 }) => {
    const res = await api.get('/Listing/GetByBounds', {
      params: { swLat, swLng, neLat, neLng, limit },
    });
    return res.data.data;
  },
};
